import React from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-bootstrap/lib/Modal';
import Button from 'react-bootstrap/lib/Button';
import ModalHeader from './ModalHeader.js';
import AlertMessage from './AlertMessage';
import { formatClassName } from '../Util';
import i18n from '../../src/i18n/translate';

export default class GenericModal extends React.Component {
  static propTypes = {
    bsSize: PropTypes.string,
    canClose: PropTypes.bool,
    children: PropTypes.node,
    footerCloseButton: PropTypes.oneOfType([
      PropTypes.shape({
        attributes: PropTypes.object,
        bsStyle: PropTypes.string,
        isTurnedOn: PropTypes.bool,
        text: PropTypes.string
      }),
      PropTypes.bool
    ]),
    id: PropTypes.string,
    message: PropTypes.string,
    messageType: PropTypes.oneOf(['danger', 'info', 'success', 'warning']),
    modalClass: PropTypes.string,
    onClose: PropTypes.func,
    saveButtonConfig: PropTypes.shape({
      attributes: PropTypes.object,
      disabled: PropTypes.bool,
      saveAction: PropTypes.func,
      saveStyle: PropTypes.string,
      saveText: PropTypes.string
    }),
    show: PropTypes.bool,
    size: PropTypes.oneOf(['small', 'medium', 'large', 'xlarge']),
    showAlert: PropTypes.bool,
    stickyFooter: PropTypes.bool,
    title: PropTypes.string
  };

  static defaultProps = {
    show: true,
    showAlert: false,
    size: 'medium',
    stickyFooter: false
  };

  renderFooter() {
    const { footerCloseButton, saveButtonConfig, stickyFooter } = this.props;
    const hasButtons = footerCloseButton && footerCloseButton.isTurnedOn || saveButtonConfig
    if (hasButtons) {
      return (
        <Modal.Footer className={stickyFooter && 'sticky-footer'}>
          {footerCloseButton.isTurnedOn &&
            <Button
              bsStyle={footerCloseButton.bsStyle}
              id="generic-modal-cancel-button"
              onClick={this.props.onClose}
              {...footerCloseButton?.attributes}
            >
              {footerCloseButton.text || i18n.t("Cancel")}
            </Button>
          }
          {saveButtonConfig &&
            <Button
              disabled={saveButtonConfig.disabled}
              id="generic-modal-save-button"
              bsStyle={saveButtonConfig.saveStyle}
              onClick={saveButtonConfig.saveAction}
              {...saveButtonConfig.attributes}
            >
              {saveButtonConfig.saveText || i18n.t("Save")}
            </Button>
          }
        </Modal.Footer>
      )
    }
  }

  getModalClasses = () => {
    const { modalClass, size, stickyFooter } = this.props;
    return formatClassName([
      `${modalClass}`,
      `modal-size-${size}`,
      { 'sticky-footer': stickyFooter }
    ])
  }

  render() {
    const {
      bsSize,
      canClose,
      id,
      message,
      messageType,
      onClose,
      show,
      showAlert,
      title
    } = this.props;
    let modalClassName = this.getModalClasses();
    return (
      <Modal id={id} className={modalClassName} bsSize={bsSize} show={show} onHide={onClose} keyboard={canClose} backdrop={canClose ? true : 'static'}>
        <ModalHeader onCancel={onClose} canClickOff={canClose} title={title} />
        <AlertMessage message={message} messageType={messageType} visible={showAlert} />
        <Modal.Body>
          {this.props.children}
        </Modal.Body>
        {this.renderFooter()}
      </Modal>
    );
  }
}
